import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminGoalMonitor } from '../components/AdminGoalMonitor';
import { SESSION_TOKEN } from '../lib/session';

// The autonomous goal monitor (admin.developerz.ai). Thin, like every other
// admin route: <AdminGate/> wraps the panel so its `/v1/admin/goals` read only
// fires for `developerz-ai` staff (the gated panel never mounts for an outsider
// → no fetch). `token` is injectable for tests; the router mounts this with no
// props → dev/prod session.

export function AdminGoals(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminGoalMonitor token={token} />
    </AdminGate>
  );
}
